export { default as BanOutlineIcon } from './BanOutlineIcon';
